/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Information related to the outcome of the operation
 * @export
 * @interface RoleMappingUpdateAll200Response
 */
export interface RoleMappingUpdateAll200Response {
    /**
     * The number of instances updated
     * @type {number}
     * @memberof RoleMappingUpdateAll200Response
     */
    count?: number;
}

/**
 * Check if a given object implements the RoleMappingUpdateAll200Response interface.
 */
export function instanceOfRoleMappingUpdateAll200Response(value: object): value is RoleMappingUpdateAll200Response {
    return true;
}

export function RoleMappingUpdateAll200ResponseFromJSON(json: any): RoleMappingUpdateAll200Response {
    return RoleMappingUpdateAll200ResponseFromJSONTyped(json, false);
}

export function RoleMappingUpdateAll200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoleMappingUpdateAll200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'] == null ? undefined : json['count'],
    };
}

export function RoleMappingUpdateAll200ResponseToJSON(json: any): RoleMappingUpdateAll200Response {
    return RoleMappingUpdateAll200ResponseToJSONTyped(json, false);
}

export function RoleMappingUpdateAll200ResponseToJSONTyped(value?: RoleMappingUpdateAll200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
    };
}

